import { Route } from '@angular/router';
import { IsLoggedInGuard, RequiresPermissionGuard } from '@lexplus-authentication';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../localized-user-routes-const';
import { LexplusPermissionsEnum } from '@lexplus-authentication-api';

export function AuswertungenPageRoute(localeId: string): Route {
  const locale = localeId?.split('-')[0] || 'en';

  return {
    path: '',
    canActivate: [IsLoggedInGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.AUSWERTUNGEN][locale],
      },
      {
        path: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.AUSWERTUNGEN][locale],
        canActivate: [RequiresPermissionGuard],
        data: {
          routeId: USER_ROUTES_IDS.AUSWERTUNGEN,
          requiredPermission: LexplusPermissionsEnum.UserAuswertungen,
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_REPORTS_ANALYSIS][locale], // Default tab
          },
          {
            path: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_REPORTS_ANALYSIS][locale],
            loadComponent: () => import('./pages/auswertungen-page/auswertungen-page.component').then((m) => m.AuswertungenPageComponent),
            data: { routeId: USER_ROUTES_IDS.USER_REPORTS_ANALYSIS },
          },
          {
            path: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_REPORTS_LOCATION_COMPARISON][locale],
            loadComponent: () => import('./pages/auswertungen-page/auswertungen-page.component').then((m) => m.AuswertungenPageComponent),
            data: { routeId: USER_ROUTES_IDS.USER_REPORTS_LOCATION_COMPARISON },
          },
        ],
      },
    ],
  };
}
